import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Dialog } from 'src/components/Dialog';
import { Theme, useMediaQuery } from 'src/components/muiTheme/utils';

import { CheckinBlockerContent } from './CheckinBlockerContent';
import { CheckinBlockerContentProps } from './_types';

export interface CheckInBlockerDialogProps
  extends Pick<
    CheckinBlockerContentProps,
    | 'users'
    | 'showUserDetails'
    | 'onOverride'
    | 'onBillingResolved'
  > {
  open: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
}

export function CheckInBlockerDialog({
  open,
  onClose,
  title,
  subtitle,
  users,
  showUserDetails = false,
  onOverride,
  onBillingResolved,
}: CheckInBlockerDialogProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title ?? t('title')}
      subtitle={subtitle}
      fullScreen={isMobile}
      maxWidth="md"
    >
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CheckinBlockerContent
          users={users}
          showUserDetails={showUserDetails}
          onOverride={onOverride}
          onBillingResolved={onBillingResolved}
        />
      </Box>
    </Dialog>
  );
}
